import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        redirect: { name: 'home' }
    },
    {
        path: '/home',
        name: 'home',
        component: () =>
            import ('../views/Home.vue')
    },
    {
        path: '/vita_mychoice',
        name: 'vita_mychoice',
        component: () =>
            import ('../views/DirectorySearch.vue')
    },
    {
        path: '/benefit',
        name: 'benefit',
        component: () =>
            import ('../views/Benefit.vue')
    },
    {
        path: '/healthcare',
        name: 'healthcare',
        component: () =>
            import ('../views/Healthcare.vue')
    },
    {
        path: '/premier',
        name: 'premier',
        component: () =>
            import ('../views/Premier.vue')
    },
    {
        path: '/logout',
        name: 'Logout',
        component: () =>
            import ('../views/Logout.vue')
    },
    {
        path: '/readPdf',
        name: 'ReadPDF',
        component: () =>
            import ('../views/ReadPDF.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router